import { render } from "./StatusCol.vue?vue&type=template&id=5dcc3abb&scoped=true"
import script from "./StatusCol.vue?vue&type=script&lang=js"
export * from "./StatusCol.vue?vue&type=script&lang=js"

import "./StatusCol.vue?vue&type=style&index=0&id=5dcc3abb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcc3abb"]])

export default __exports__